import { render, staticRenderFns } from "./TranslationCostHint.vue?vue&type=template&id=98360f2a&"
import script from "./TranslationCostHint.vue?vue&type=script&lang=js&"
export * from "./TranslationCostHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports